import {useCallback} from 'react'
import type {SearchResults} from '../types'
import {
  getValidPublisherFromParsedQuery,
  getValidCategoryFromParsedQuery as getValidModelsCategoryFromParsedQuery,
  getValidSortFromParsedQuery as getValidModelsSortFromParsedQuery,
  getValidTaskFromParsedQuery,
} from '../utilities/model-filter-options'
import {useCategory} from '../contexts/CategoryContext'
import {useModelsTask} from '../contexts/ModelsTaskContext'
import {useModelsPublisher} from '../contexts/ModelsPublisherContext'
import {useSort} from '../contexts/SortContext'
import {useModelsSearchFilters} from './use-models-search-filters'

export function useOnModelsParsedQueryChange() {
  const {setCategory} = useCategory()
  const {setTask} = useModelsTask()
  const {setPublisher} = useModelsPublisher()
  const {setSort} = useSort()
  const {
    data: {categories, publishers},
  } = useModelsSearchFilters()

  const onModelsParsedQueryChange = useCallback(
    (parsedQuery: SearchResults['parsedQuery']) => {
      const categoryFromParsedQuery = getValidModelsCategoryFromParsedQuery(parsedQuery, categories)
      if (categoryFromParsedQuery) setCategory(categoryFromParsedQuery)

      const taskFromParsedQuery = getValidTaskFromParsedQuery(parsedQuery)
      if (taskFromParsedQuery) setTask(taskFromParsedQuery)

      const publisherFromParsedQuery = getValidPublisherFromParsedQuery(
        parsedQuery,
        publishers.map(p => p.name),
      )
      if (publisherFromParsedQuery) setPublisher(publisherFromParsedQuery)

      const sortFromParsedQuery = getValidModelsSortFromParsedQuery(parsedQuery)
      if (sortFromParsedQuery) setSort(sortFromParsedQuery)
    },
    [categories, publishers, setCategory, setPublisher, setSort, setTask],
  )

  return onModelsParsedQueryChange
}
